export enum ClpPopulation {
  AUTO = 'auto',
  NAME = 'clp_population',
  QUERY = 'query',
}

/**
 * The Release 2 A/B test of the product card image gallery (DISC-4591).
 *
 * `SINGLE` is the control: the card is handed the hero alone, so it draws a plain
 * frame with no dots, no swipe and no hover reveal. `MULTIPLE` is the gallery.
 */
export enum ProductCardImage {
  MULTIPLE = 'multiple',
  NAME = 'plp_product_card_image',
  SINGLE = 'single',
}
